import { render, staticRenderFns } from "./prognDevDiffVoda.vue?vue&type=template&id=33e6e4db"
import script from "./prognDevDiffVoda.vue?vue&type=script&lang=js"
export * from "./prognDevDiffVoda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports